import React from "react";
import PropTypes from "prop-types";
import { render as rtlRender } from "@testing-library/react";
import { IntlProvider } from "react-intl";
import locales from "locales/data.json";
import { getBrandRichTextElements } from "constants/brands";

/**
 * Wrap providers and export libraries
 */
function render(ui, { locale = "en", ...renderOptions } = {}) {
  function Wrapper({ children }) {
    return (
      <IntlProvider locale={locale} messages={locales[locale]} defaultRichTextElements={getBrandRichTextElements()}>
        {children}
      </IntlProvider>
    );
  }

  Wrapper.propTypes = {
    children: PropTypes.node.isRequired,
  };

  return rtlRender(ui, { wrapper: Wrapper, ...renderOptions });
}

function setStubs() {
  // Prevent media elements from returning from triggering error:
  // Not implemented: HTMLMediaElement.prototype
  window.HTMLMediaElement.prototype.load = () => {};
  window.HTMLMediaElement.prototype.play = () => {};
  window.HTMLMediaElement.prototype.pause = () => {};
  window.HTMLMediaElement.prototype.addTextTrack = () => {};
}

export { render, setStubs };
export * from "@testing-library/react";
export * from "@testing-library/jest-dom";
